<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.employmentYear.regularMaleEmploymentYear.$invalid 
      || $v.employmentYear.nonRegularMaleEmploymentYear.$invalid
      || $v.employmentYear.achievementMaleEmploymentYear.$invalid 
      || $v.employmentYear.regularFemaleEmploymentYear.$invalid 
      || $v.employmentYear.nonRegularFemaleEmploymentYear.$invalid
      || $v.employmentYear.achievementFemaleEmploymentYear.$invalid 
      || $v.employmentYear.regularEmploymentYear.$invalid
      || $v.employmentYear.nonRegularEmploymentYear.$invalid
      || $v.employmentYear.corpEmploymentYear.$invalid 
      || $v.employmentYear.resultMemo.$invalid 
      || $v.employmentYear.actionMemo.$invalid">
      <div v-if="$v.employmentYear.regularMaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（正社員・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularMaleEmploymentYear.$invalid && !$v.employmentYear.regularMaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularMaleEmploymentYear.$invalid && $v.employmentYear.regularMaleEmploymentYear.customDoubleNum && !$v.employmentYear.regularMaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.nonRegularMaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（非正規・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularMaleEmploymentYear.$invalid && !$v.employmentYear.nonRegularMaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularMaleEmploymentYear.$invalid && $v.employmentYear.nonRegularMaleEmploymentYear.customDoubleNum && !$v.employmentYear.nonRegularMaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.achievementMaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（全社・男性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.achievementMaleEmploymentYear.$invalid && !$v.employmentYear.achievementMaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.achievementMaleEmploymentYear.$invalid && $v.employmentYear.achievementMaleEmploymentYear.customDoubleNum && !$v.employmentYear.achievementMaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.regularFemaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（正社員・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularFemaleEmploymentYear.$invalid && !$v.employmentYear.regularFemaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularFemaleEmploymentYear.$invalid && $v.employmentYear.regularFemaleEmploymentYear.customDoubleNum && !$v.employmentYear.regularFemaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.nonRegularFemaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（非正規・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularFemaleEmploymentYear.$invalid && !$v.employmentYear.nonRegularFemaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularFemaleEmploymentYear.$invalid && $v.employmentYear.nonRegularFemaleEmploymentYear.customDoubleNum && !$v.employmentYear.nonRegularFemaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.achievementFemaleEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（全社・女性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.achievementFemaleEmploymentYear.$invalid && !$v.employmentYear.achievementFemaleEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.achievementFemaleEmploymentYear.$invalid && $v.employmentYear.achievementFemaleEmploymentYear.customDoubleNum && !$v.employmentYear.achievementFemaleEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>

      <div v-if="$v.employmentYear.regularEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（正社員）　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularEmploymentYear.$invalid && !$v.employmentYear.regularEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.regularEmploymentYear.$invalid && $v.employmentYear.regularEmploymentYear.customDoubleNum && !$v.employmentYear.regularEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.nonRegularEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（非正規）　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularEmploymentYear.$invalid && !$v.employmentYear.nonRegularEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.nonRegularEmploymentYear.$invalid && $v.employmentYear.nonRegularEmploymentYear.customDoubleNum && !$v.employmentYear.nonRegularEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>
      <div v-if="$v.employmentYear.corpEmploymentYear.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均継続勤務年数（全社）　　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.corpEmploymentYear.$invalid && !$v.employmentYear.corpEmploymentYear.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.employmentYear.corpEmploymentYear.$invalid && $v.employmentYear.corpEmploymentYear.customDoubleNum && !$v.employmentYear.corpEmploymentYear.between" validation="between" valueMin="0" valueMax="99.9"/>
      </div>

      <div v-if="$v.employmentYear.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ　　　　　　　　：</span>
        <ValidationErrorMessage v-show="$v.employmentYear.resultMemo.$invalid && !$v.employmentYear.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.employmentYear.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション　　　　　　　：</span>
        <ValidationErrorMessage v-show="$v.employmentYear.actionMemo.$invalid && !$v.employmentYear.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">平均継続勤務年数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.regularMaleEmploymentYear" type="text" name="employmentYear.regularMaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.nonRegularMaleEmploymentYear" type="text" name="employmentYear.nonRegularMaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-important">
                  <TextBox v-model.trim="$v.employmentYear.$model.achievementMaleEmploymentYear" type="text" name="employmentYear.achievementMaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.regularFemaleEmploymentYear" type="text" name="employmentYear.regularFemaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.nonRegularFemaleEmploymentYear" type="text" name="employmentYear.nonRegularFemaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-important">
                  <TextBox v-model.trim="$v.employmentYear.$model.achievementFemaleEmploymentYear" type="text" name="employmentYear.achievementFemaleEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.regularEmploymentYear" type="text" name="employmentYear.regularEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.nonRegularEmploymentYear" type="text" name="employmentYear.nonRegularEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.employmentYear.$model.corpEmploymentYear" type="text" name="employmentYear.corpEmploymentYear" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">年</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="employmentYear.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(employmentYear.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="employmentYear.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { between, maxLength } from 'vuelidate/lib/validators';
//import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
//    Currency,
  },
  props: {
    // 表示年度の平均継続勤務年数データ
    employmentYear: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "年",
    }
  },
  computed: {
  },
  validations: {
    employmentYear: {
      regularMaleEmploymentYear : { 
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      }, // 平均継続勤務年数（正規・男性）
      nonRegularMaleEmploymentYear : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（非正規・男性）
      achievementMaleEmploymentYear : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 実績　平均継続勤務年数（男性）
      regularFemaleEmploymentYear : { 
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（正規・女性）
      nonRegularFemaleEmploymentYear : {
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（非正規・女性）
      achievementFemaleEmploymentYear : { 
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 実績　平均継続勤務年数（女性）
      regularEmploymentYear : { 
        between: between(0,99.9), 
        customDoubleNum: (value) => { 
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（正規）
      nonRegularEmploymentYear : {
        between: between(0,99.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（非正規）
      corpEmploymentYear : {
        between: between(0,99.9),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },  // 平均継続勤務年数（全社）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    employmentYear() {
      this.inputEmploymentYear();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputEmploymentYear() {
      this.$emit("change-employment-year", {
        employmentYear: this.employmentYear,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
